import { WSMutationConfig } from "@ws-react-query";
import { useWSMutation } from "../../helpers";
import { WSServiceError } from "../../../utils/serviceHelper";
import { deleteEngagement } from "../../../services/engagements";
import { QUERY_ENGAGEMENT_LIST, QUERY_ENGAGEMENT_LIST_SIZE } from "../keys";
import { QUERY_LIST_RESOURCE_EVENTS } from "../../resourceEvents/queries/useQueryListEvents";

export const useMutationDeleteEngagement = (
  config?: WSMutationConfig<void, WSServiceError>
) =>
  useWSMutation((engagementId: string) => deleteEngagement(engagementId), {
    ...config,
    dependencies: [
      QUERY_ENGAGEMENT_LIST,
      QUERY_ENGAGEMENT_LIST_SIZE,
      QUERY_LIST_RESOURCE_EVENTS
    ]
  });
